// extracted by mini-css-extract-plugin
export default {"wrap":"TJ-z","heading":"UJ-z"};